<nimbus-companion-chat-history></nimbus-companion-chat-history>
<div class="panel">
  <nimbus-companion-chat-panel></nimbus-companion-chat-panel>
</div>
